import React, { useEffect } from 'react'
import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import Dialog from '@mui/material/Dialog'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { combineSchema } from '../validators'
import i18n from '../../../i18n'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import {
  modalCombineData,
  modalCombineIsVisible,
  selectedTrainingWorkoutType
} from '../../../redux/reducers/training-workout/training-workout.selectors'
import {
  combineTrainingWorkout,
  resetModalCombine,
  updateTypeGroupTrainingWorkout
} from '../../../redux/reducers/training-workout/training-workout.actions'
import { Button } from '../../Button'
import { Select } from '../../Select'
import {
  ModalCombineData,
  ModalCombineDataEdit
} from '../../../redux/reducers/training-workout/training-workout.reducer'

const typesCombination = [
  { label: i18n.t('trainingWorkout.type.DROP_SET'), value: 'DROP_SET' },
  { label: i18n.t('trainingWorkout.type.BI_SET'), value: 'BI_SET' },
  { label: i18n.t('trainingWorkout.type.TRI_SET'), value: 'TRI_SET' },
  { label: i18n.t('trainingWorkout.type.COMBINED'), value: 'COMBINED' }
]

export type CombineProps = {
  typeCombine: string
}

function isModalData (obj: any): obj is ModalCombineData {
  if (obj == null) return false
  return 'items' in obj
}

function isModalDataEdit (obj: any): obj is ModalCombineDataEdit {
  if (obj == null) return false
  return 'groupTrainingWorkout' in obj
}

export const ModalCombine = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const isVisible = useAppSelector(modalCombineIsVisible)
  const trainingWorkoutType = useAppSelector(selectedTrainingWorkoutType)

  const data = useAppSelector(modalCombineData)

  const { control, reset, setValue, handleSubmit } = useForm<CombineProps>({
    resolver: yupResolver(combineSchema)
  })

  useEffect(() => {
    if (isVisible) {
      reset()
    }
    dataFetch().catch(console.error)
  }, [isVisible])

  const dataFetch = async () => {
    if (isModalData(data)) return
    const fields = ['typeCombine']
    fields.forEach((field: any) => setValue(field, data?.groupTrainingWorkout.type))
  }

  const handleSaveCombine = async (combineProps: CombineProps): Promise<void> => {
    if (data == null) return
    if (isModalData(data)) {
      await dispatch(combineTrainingWorkout({
        type: trainingWorkoutType,
        payload: {
          type: combineProps.typeCombine,
          trainingWorkoutIds: data.items ?? []
        }
      }))
    }
    if (isModalDataEdit(data)) {
      await dispatch(updateTypeGroupTrainingWorkout({
        groupTrainingWorkoutId: data.groupTrainingWorkout.id,
        type: trainingWorkoutType,
        payload: {
          type: combineProps.typeCombine
        }
      }))
    }
    onClose()
  }

  const onClose = () => {
    dispatch(resetModalCombine())
  }

  return (
    <Dialog maxWidth="lg" open={isVisible} onClose={onClose}>
      <DialogTitle>{t('trainingWorkout.combineWorkout')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} m={4} width={{ md: 350, sm: 350 }}>
          <Controller
            control={control}
            name="typeCombine"
            defaultValue={'BI_SET'}
            render={({ field: { onChange, value } }: any) => (
              <Select
                value={value}
                onChange={onChange}
                label={`${t('trainingWorkout.labelCombination')}`}
                items={typesCombination}
                errorMessage={''}
              />
            )} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} justifyContent="end">
          <Button
            title={'Cancelar'}
            color="secondary"
            onClick={onClose} />
          <Button
            title={'Combinar'}
            onClick={handleSubmit(handleSaveCombine)} />
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
